import { React, classNames } from '@digsup/core-ui';
import PropTypes from 'prop-types';
import { TestimonialsItem } from './TestimonialsItem';
import { styles } from './Testimonials.scss';

const cx = classNames.bind(styles);

const Testimonials = ({ children }) => (
  <div className={cx('l-homepage-testimonials')}>
    <div className="l-homepage-testimonials__wrapper">{children}</div>
  </div>
);

Testimonials.propTypes = {
  children: PropTypes.any,
};

export { Testimonials, TestimonialsItem };
